module.exports = __webpack_public_path__ + "img/important.82dd3000.svg";